export default "/_next/static/images/diamond-1f9eceac2c3fb11256eda6934c230d93.svg";